<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <h6>账号列表</h6>
      <!-- Search Section -->
      <div class="d-flex align-items-center mb-3">
        <!-- Dropdown for search criteria -->
        <select v-model="searchCriteria" class="form-select me-3" aria-label="Search Criteria">
          <option value="全部用户">全部用户</option>
          <option value="user_id">平台用户ID</option>
          <option value="parent_id">上级账号ID</option>
          <option value="mobile">手机号</option>
          <option value="nick_name">昵称</option>
          <option value="merchant_uid">商户用户ID</option>
        </select>
        
        <!-- Text Input for Search -->
        <input v-if="searchCriteria !== '全部用户'" v-model="searchText" type="text" class="form-control" placeholder="请输入搜索内容" />

        <!-- Search Button -->
        <button @click="handleSearch" class="btn btn-primary mb-0 ms-3 search-btn">
         <i class="fas fa-search"></i>
        </button>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <!-- 头像 -->
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                头像
              </th>
              <!-- 账号ID -->
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                账号ID
              </th>
              <!-- 昵称 -->
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                昵称
              </th>
              <!-- 手机号 -->
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                手机号
              </th>
              <!-- 上级ID -->
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                上级ID
              </th>
              <!-- 入驻时间 -->
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                入驻时间
              </th>
              <!-- 状态 -->
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                状态
              </th>
              <!-- 操作 -->
              <th class="text-secondary opacity-7"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(author, index) in paginatedData" :key="index">
              <!-- 头像列 -->
              <td>
                <div class="d-flex px-2 py-1">
                  <div>
                    <soft-avatar :img="author.Imgurl || author.avatar" size="sm" border-radius="lg" class="me-3" alt="avatar" />
                  </div>
                </div>
              </td>
              <!-- 账号ID -->
              <td>
                <div class="d-flex px-2 py-1">
                  <div>
                    <h6 class="mb-0 text-sm">{{ author.Id }}</h6> <!-- 显示账号ID -->
                  </div>
                </div>
              </td>
              <!-- 昵称 -->
              <td>
                <p class="text-xs font-weight-bold mb-0">{{ getUserDisplayName(author) }}</p> <!-- 优先显示：进件资料户名->手动设置昵称->默认值 -->
              </td>
              <!-- 手机号 -->
              <td class="align-middle text-center text-sm">
                <p class="text-xs text-secondary mb-0">{{ author.Mobile }}</p> <!-- 显示手机号 -->
              </td>
              <!-- 上级ID -->
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">{{ author.ParentId }}</span> <!-- 显示上级ID -->
              </td>
              <!-- 入驻时间 -->
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">{{ formattedDate(author.Date) }}</span>
              </td>
              <!-- 状态 -->
              <td class="align-middle text-center">
                <span class="badge" :class="author.Active !== 0 ? 'bg-success' : 'bg-secondary'">
                  {{ author.Active !== 0 ? '正常' : '已禁用' }}
                </span>
              </td>
              <!-- 操作 -->
              <td class="align-middle">
                <soft-button 
                  @click="toggleMenu(index)" 
                  class="text-secondary font-weight-bold text-xs"
                  :style="{backgroundColor: menuVisibleIndex === index? '#f1f1f1':'',
                    color: menuVisibleIndex === index? '#6c757d':'white'}">
                  {{ menuVisibleIndex === index? '操作':'操作>>' }}
                </soft-button>
                <!-- 操作菜单 -->
                <div v-if="menuVisibleIndex === index" class="menu">
                  <ul>
                    <li @click="editPassword(author)" style="margin-left:-10px;">修改密码</li>
                    <li @click="toggleUserActive(author)" style="margin-left:-10px;">{{ author.Active !== 0 ? '禁用' : '启用' }}</li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination Controls -->
      <div class="d-flex justify-content-between align-items-center mt-3 px-3">
        <!-- Previous Button with more padding and margin -->
        <button class="btn btn-outline-dark" @click="changePage(currentPage - 1)" :disabled="currentPage <= 1" style="margin-right: 20px;">
          上一页
        </button>

        <!-- Page info -->
        <div class="text-center">
          第 {{ currentPage }} 页/ 总 {{ totalPages }} 页
        </div>

        <!-- Next Button with more padding and margin -->
        <button class="btn btn-outline-dark" @click="changePage(currentPage + 1)" :disabled="currentPage >= totalPages" style="margin-left: 20px;">
          下一页
        </button>
      </div>
    </div>
  </div>

</template>

<script>
import SoftAvatar from "@/components/SoftAvatar.vue";
import { getuserlist, setloginpassword, setUserActive } from "@/api/user.js"
import { getMerchantInfoMap } from "@/utils/merchantCache"
import SoftButton from "@/components/SoftButton.vue"
import dayjs from "dayjs";
import md5 from 'md5'

export default {
  name: "users-table",
  data() {
    return {
      // 默认头像数组
      avatarImages: [
        require("../../assets/img/team-2.jpg"),
        require("../../assets/img/team-3.jpg"),
        require("../../assets/img/team-4.jpg"),
        require("../../assets/img/team-1.jpg")
      ],
      authors: [],
      currentPage: 1,
      itemsPerPage: 10,
      searchCriteria: "全部用户",
      searchText: "",
      menuVisibleIndex: null, // Track the index of the visible menu
      merchantInfoMap: {}, // deliver_id -> merchant info (account_holder, name, etc.)
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.authors.length / this.itemsPerPage);
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.authors.slice(start, end);
    }
  },
  methods: {
    getUserDisplayName(author) {
      const info = this.merchantInfoMap[author.DeliverId] || {};
      return info.account_holder || author.NickName || info.name || ('商家' + author.Id);
    },
    async fetchMerchantInfo() {
      try {
        this.merchantInfoMap = await getMerchantInfoMap();
      } catch (err) {
        console.error("获取商户信息失败:", err);
      }
    },
    changePage(page) {
      if (page < 1 || page > this.totalPages) return;
      this.currentPage = page;
    },

    handleSearch() {
      let params = {}
      if (this.searchCriteria !== '全部用户') {
        params[this.searchCriteria] = this.searchText
      }
      getuserlist(params).then(response=>{
        console.log("get user info:", response)
        if (response.code === 0 ) {
            this.authors = response.desc
            this.currentPage = 1
            this.setRandomAvatars()
        }else{
          alert(response.desc)
        }       
      }).catch(error => {
        console.log('error fetching user data:', error)
	     })

    },
 // 显示或隐藏菜单
    toggleMenu(index) {
      this.menuVisibleIndex = this.menuVisibleIndex === index ? null : index; // Toggle visibility
    },
    // 修改密码
    editPassword(author) {
      const newPassword = prompt("请输入新密码：");

      if (!newPassword) {
        alert("新密码不能为空！");
        return;
      }

      if (confirm(`您确定要修改账号 ${author.Id} 的密码吗？`)) {
        this.changePassword(author, newPassword);
      }
    },
    setRandomAvatars() {
      this.authors.forEach(author => {
        // 从avatarImages数组中随机选择一个头像
        const randomIndex = Math.floor(Math.random() * this.avatarImages.length);
        author.avatar = this.avatarImages[randomIndex];
      });
    },
    formattedDate(timestamp) {
      return dayjs.unix(timestamp).format('YYYY/MM/DD HH:mm:ss');
    },

    changePassword(author, newPassword) {
      // 获取用户的账户信息
      const userAccount = author.Mobile;  // 账号使用手机号

      // 计算 MD5
      const userPass = md5(userAccount + newPassword);  // md5(pass + mobile)

          // 调用接口修改密码
          const params = {
            user_id: author.Id,  // 传递用户ID
            user_pass: userPass,  // 传递计算后的MD5密码
          };

          setloginpassword(params)
            .then(response => {
              if (response.code === 0) {
                alert("密码修改成功！");
              } else {
                alert("密码修改失败：" + response.desc);
              }
            })
            .catch(error => {
              console.error("修改密码时出错：", error);
              alert("密码修改失败，请稍后再试。");
            });
    },
    toggleUserActive(author) {
      const newActive = author.Active !== 0 ? 0 : 1
      const actionText = newActive === 1 ? '启用' : '禁用'
      if (!confirm(`确定要${actionText}账号 ${author.Id} (${author.Mobile}) 吗？`)) return
      setUserActive({ user_id: author.Id, active: newActive }).then(response => {
        if (response.code === 0) {
          alert(`${actionText}成功`)
          this.handleSearch()
        } else {
          alert(`${actionText}失败：` + response.desc)
        }
      }).catch(error => {
        console.error(`${actionText}时出错：`, error)
        alert(`${actionText}失败，请稍后再试。`)
      })
    },

  },
  components: {
    SoftAvatar,
    SoftButton,
  },
  mounted() {
    this.setRandomAvatars(); // 页面加载时为每个作者设置头像
    this.fetchMerchantInfo();
    this.searchCriteria !== '全部用户'
    this.handleSearch()
  }
};
</script>

<style scoped>
/* 搜索按钮独立样式：与 .form-control 等高且中心线对齐 */
.search-btn {
  height: calc(1.4rem + 1rem + 2px); /* line-height + padding-y*2 + border*2 */
  width: calc(1.4rem + 1rem + 2px);
  padding: 0;
  line-height: 1;
}

menu {
  position: absolute;
  background-color: white;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 5px;
  z-index: 10;
  max-width: 80px;
}

.menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
  max-width: 80px;
}

.menu ul li {
  padding: 8px 16px;
  cursor: pointer;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.8rem;
  border-radius: 0.5rem;
  text-align: center;
  padding: 5px;
  margin-top: 8px;
}

.menu ul li:hover {
  background-color: #f1f1f1;
}
</style>
